import PropTypes from "prop-types";
import React from "react";
import Typography from "@material-ui/core/Typography";
import "./../Utils/extensions.js";

/**
 * Рекурсивно извлекает текстовое содержимое из children произвольной вложенности.
 * Нужно для проверки арабского текста, когда children может быть строкой,
 * одиночным React-элементом или вложенной структурой элементов (например, <strong><em>текст</em></strong>).
 *
 * @param {*} children - Значение props.children (строка, число, React-элемент, массив).
 * @returns {string} Извлечённый текст (пустая строка, если текста нет).
 */
const extractText = (children) => {
  if (children == null || typeof children === "boolean") return "";
  if (typeof children === "string" || typeof children === "number") return String(children);
  if (Array.isArray(children)) return children.map(extractText).join("");
  if (typeof children === "object" && children.props) return extractText(children.props.children);
  return "";
};

//const useStyles = makeStyles(
//  () => ({
//    root: {
//      fontSize: ({ isArabic, arabicSize }) => {
//        if (isArabic === true) {
//          return arabicSize;
//        }
//      },
//      position: "relative",
//      "&::before": {
//        content: ({ isArabic, arabicSize }) => `'${isArabic} - ${arabicSize}'`,
//        color: "red",
//        position: "absolute",
//        top: -15,
//        fontSize: 10,
//        whiteSpace: "nowrap",
//      },
//    },
//  }),
//  {
//    name: "ArabicTypography",
//  },
//);

/** @param {Number} arabicSize
 * @param {Object} rest
 * @returns {*}
 * @constructor
 */
const TypographyArabic = ({ arabicSize, ...rest }) => {
  const text = extractText(rest.children);
  const isArabic = text.isArabic();
  //const classes = useStyles({ isArabic, arabicSize });

  return (
    <Typography
      {...rest}
      //classes={{
      //  root: classes.root,
      //}}
      style={{ fontSize: isArabic ? arabicSize : undefined }}
    />
  );
};

TypographyArabic.propTypes = {
  arabicSize: PropTypes.number,
  children: PropTypes.node,
  ...Typography.propTypes,
};

TypographyArabic.defaultProps = {
  arabicSize: 26,
};

export default TypographyArabic;
